import { useState } from 'react';

import { LOST_REASON_LABELS, type LostReason } from '../../api/types';
import { Button } from '../ui/button';
import { Select } from '../ui/select';

export interface LostReasonModalProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: (reason: LostReason) => void;
}

export function LostReasonModal({ open, onCancel, onConfirm }: LostReasonModalProps) {
  const [reason, setReason] = useState<LostReason>('other');
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center bg-black/40 p-4">
      <div className="w-full max-w-sm rounded bg-card p-5 shadow-xl">
        <h2 className="mb-3 text-lg font-semibold">Причина потери контакта</h2>
        <Select
          aria-label="Причина потери"
          value={reason}
          onChange={(e) => setReason(e.target.value as LostReason)}
          className="w-full"
        >
          {(Object.keys(LOST_REASON_LABELS) as LostReason[]).map((r) => (
            <option key={r} value={r}>
              {LOST_REASON_LABELS[r]}
            </option>
          ))}
        </Select>
        <div className="mt-4 flex justify-end gap-2">
          <Button variant="secondary" onClick={onCancel}>
            Отмена
          </Button>
          <Button variant="danger" onClick={() => onConfirm(reason)}>
            Перенести в «Потерян»
          </Button>
        </div>
      </div>
    </div>
  );
}
